import { useEffect, useState } from 'react';

/**
 * Returns a copy of `value` that only updates after it has stayed
 * unchanged for `delayMs` milliseconds.
 */
export function useDebouncedValue<T>(value: T, delayMs = 220): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debouncedValue;
}
